import React from 'react';
import { Hero } from '../components/Hero';
import { Logos } from '../components/Logos';
import { Problem } from '../components/Problem';
import { CastingCalls } from '../components/CastingCalls';
import { RosterDatabase } from '../components/RosterDatabase';
import { Audiences } from '../components/Audiences';
import { ProductWorkflow } from '../components/ProductWorkflow';
import { Moat } from '../components/Moat';
import { CTA } from '../components/CTA';
import { InfluencerHub, CapterraReviews, Newsletter, ComingSoon } from '../components/HomeExtras';
import { Testimonials, BRAND_TESTIMONIALS } from '../components/Testimonials';
export const Home = () => {
  return <>
      <Hero data-id="element-1909" />
      <Logos data-id="element-1910" />
      <Problem data-id="element-1911" />
      <CastingCalls data-id="element-1912" />
      <RosterDatabase data-id="element-1913" />
      <Audiences data-id="element-1914" />
      <ProductWorkflow data-id="element-1915" />
      <Moat data-id="element-1916" />
      <Testimonials title="Loved by top brands and agencies" items={BRAND_TESTIMONIALS} data-id="element-1917" />
      <InfluencerHub data-id="element-1918" />
      <CapterraReviews data-id="element-1919" />
      <ComingSoon data-id="element-1920" />
      <CTA data-id="element-1921" />
      <Newsletter data-id="element-1922" />
    </>;
};